import React from 'react';

export function DigitalInvitesPriceBadges({ fromLabel, primary, secondary, customLabel }) {
  const badgeClass =
    'flex min-h-[68px] min-w-[68px] items-center justify-center rounded-full bg-gradient-to-br from-amber-400/90 via-amber-500 to-amber-600 shadow-[0_8px_28px_-8px_rgba(245,158,11,0.55),inset_0_1px_0_rgba(255,255,255,0.35)] border border-amber-300/30 px-3';

  if (customLabel) {
    return (
      <div className="flex flex-col items-center justify-center text-center min-w-[88px]">
        <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-amber-300/80 mb-3">{fromLabel}</p>
        <div className={`${badgeClass} h-[72px] w-[72px]`}>
          <span className="text-xs font-bold text-slate-950 text-center leading-tight">{customLabel}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center text-center min-w-[88px]">
      <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-amber-300/80 mb-3">{fromLabel}</p>
      <div className="flex flex-col gap-2.5">
        {primary ? (
          <div className={badgeClass}>
            <span className="text-sm sm:text-base font-black text-slate-950 tabular-nums leading-none whitespace-nowrap">
              {primary}
            </span>
          </div>
        ) : null}
        {secondary ? (
          <div className={badgeClass}>
            <span className="text-sm sm:text-base font-black text-slate-950 tabular-nums leading-none whitespace-nowrap">
              {secondary}
            </span>
          </div>
        ) : null}
      </div>
    </div>
  );
}
